import { render } from "./AllGoals.vue?vue&type=template&id=310dea88"
import script from "./_AllGoals.js?vue&type=script&lang=js&external"
export * from "./_AllGoals.js?vue&type=script&lang=js&external"

import "./_AllGoals.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__